import React from 'react';
import TerminalWindow from './TerminalWindow';
import DirectoryWindow from './DirectoryWindow';

class App extends React.Component {
  constructor() {
    super();

    this.toggleDir = this.toggleDir.bind(this);
    this.getTerminal = this.getTerminal.bind(this);
    this.updateTerminal = this.updateTerminal.bind(this);

    this.state = {
      loaded: false,
      dir: false,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        loaded: true,
      });
    }, 200);

    setTimeout(() => {
      this.setState({
        dir: true,
      });
    }, 1000);
  }

  toggleDir() {
    this.setState({
      dir: !this.state.dir
    });
  }

  getTerminal() {
    return this.refs.terminal;
  }

  updateTerminal() {
    this.forceUpdate();
  }

  render() {
    let state = this.state;

    return (
      <div className="container-wrapper">
        <div className={`container ${state.loaded ? 'loaded' : ''} ${state.dir ? 'second-window' : ''}`}>
          <TerminalWindow updateTerminal={this.updateTerminal} ref="terminal" toggleDir={this.toggleDir} />
          <DirectoryWindow getTerminal={this.getTerminal} terminal={state.terminal} />
        </div>
      </div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js